// extracted by mini-css-extract-plugin
export var close_icon = "Header-module--close_icon--5d311";
export var hamburger = "Header-module--hamburger--b09e8";
export var header_sticky = "Header-module--header_sticky--a3808";
export var menu = "Header-module--menu--2487e";
export var menuActive = "Header-module--menuActive--18b5c";